/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 24/10/2023
 */

import React from "react";
import { Container } from "@mui/material";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Details from "../Components/Home/Details";
import Offers from "../Components/Home/Offers";
import Categories from "../Components/Home/Categories";
import Reviews from "../Components/Home/Reviews";
import Carousel from "../Components/Home/Carousel";

const HomePage = () => {

  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToCategories) {
      const scrollToCategories = () => {
        const categoriesSection = document.getElementById("categories-section");
        // console.log("Attempting to scroll to categories:", categoriesSection);

        if (categoriesSection) {
          categoriesSection.scrollIntoView({ behavior: "smooth" });
        } else {
          console.warn("Categories section not found!");
        }
      };
      setTimeout(scrollToCategories, 100);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Adelaide - Housekeeping | Home Cleaning | Office Cleaning in Adelaide - Australia | Domestic house cleaning | Office cleaning | Garden cleaning | Y-DIY | offers</title>
        <meta name="title" content="Welcome to Doneright housekeepers" />
        {/* OpenGraph data */}
        <meta property="og:title" content="Welcome to Doneright housekeepers" />
        <meta
          property="og:description" // SHOULD CHANGE
          content="Welcome to Doneright housekeepers, your trusted partner for immaculate cleaning services in Adelaide."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_IMAGE_URL}DoneRight/HOME/doneRightLogo.png`}
        />
        <meta property="og:image:width" content="400" />
        <meta property="og:image:height" content="300" />
        <meta property="og:site_name" content="DoneRight" />
        <link rel="canonical" href={`${process.env.prodUrl}/`} key="canonical" />
      </Helmet>
      <div
        style={{
          // backgroundImage: `url(https://n-ach-file-directory.sgp1.digitaloceanspaces.com/E_SERVICE/BackgroundDR2.png)`,
          backgroundSize: "contain",
        }}
      >
        <Container style={{ margin: '0rem auto', maxWidth: '1500px' }}>
          <Carousel />
          <Categories id="categories-section" />
          <img src={`${process.env.REACT_APP_IMAGE_URL}DoneRight/HOME/homeImgD2.png`} alt="banner image 1" width={"100%"} loading='lazy' />
          <Details />
          <img src={`${process.env.REACT_APP_IMAGE_URL}DoneRight/HOME/homeImgD1.png`} alt="banner image 2" width={"100%"} loading='lazy' />
          <Offers />
          <Reviews id="reviews" />
                  </Container>
      </div>
    </>
  );
};

export default HomePage;
